import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import Timeline from "./Timeline";
import Whiteboard from "./Whiteboard";
import Editor from "./Editor";
import style from "./Manager.module.css";

@observer
class Manager extends React.Component {
  render() {
    const descriptionClass = this.props.store.onFirstStep
      ? style.descriptionFirst
      : style.description;
    return (
      <div className={style.manager}>
        <div className={style.top}>
          <Timeline store={this.props.store} />
        </div>
        <div className={style.bottom}>
          <div className={descriptionClass}>
            <Whiteboard store={this.props.store} />
          </div>
          <div className={style.editor}>
            <Editor store={this.props.store} />
          </div>
        </div>
      </div>
    );
  }
}
Manager.propTypes = {
  store: PropTypes.object.isRequired
};
export default Manager;



// WEBPACK FOOTER //
// ./src/byos/component/Manager.js